import React from 'react';
import PropTypes from  'prop-types';
import  { withStyles } from  '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';


const styles = theme => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
  listRoot: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 200,
  },
  menu: {
    width: 200,
  },
  nested: {
    paddingLeft: theme.spacing.unit * 4,
  },
});


class CampaignFailDialog extends React.Component {

  render() {
    const { classes, close } = this.props

    return (
        <Dialog
          maxWidth={false}
          open={true}
          onClose={this.handleClose}
          aria-labelledby="form-dialog-title"
        >
            <DialogTitle>
                Campaign Update Error
            </DialogTitle>
            <DialogContent>
                There was an error updating your campaign balance. Please make sure you have enough credit available.
            </DialogContent>

            <DialogActions>
                <Button onClick={close()}> Ok </Button>
            </DialogActions>
            </Dialog>

    );
  }
}

CampaignFailDialog.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(CampaignFailDialog);


// WEBPACK FOOTER //
// ./src/components/Leads/Campaigns/CampaignFailDialog.js